<template>
  <div class="breakdown-items">
    <div class="breakdown-item">
      <v-icon>zoom_in</v-icon>
      <span class="count-text">
        {{ totalReferences }}
      </span>
      <span class="appended-text">references</span>
    </div>
    <div class="breakdown-item">
      <v-icon color="success">add_circle</v-icon>
      <span class="count-text">
        {{ reportsIncluded }}
      </span>
      <span class="appended-text">included</span>
    </div>
    <div class="breakdown-item">
      <v-icon color="error">remove_circle</v-icon>
      <span class="count-text">
        {{ totalExcluded }}
      </span>
      <span class="appended-text">excluded</span>
    </div>
    <div class="breakdown-item">
      <v-icon color="grey">help</v-icon>
      <span class="count-text">
        {{ totalPending }}
      </span>
      <span class="appended-text">pending</span>
    </div>
  </div>
</template>

<script>
import { Revision } from '@/models';

export default {
  name: 'RevisionCardReferenceBreakdown',
  props: {
    revision: {
      type: Revision,
      required: true,
    },
  },
  computed: {
    totalReferences() {
      return this.formatNumber(
        this.revision.prismaStats.totalNonDuplicateRecords()
      );
    },
    reportsIncluded() {
      return this.formatNumber(
        this.revision.prismaStats.reportsIncluded
      );
    },
    totalExcluded() {
      return this.formatNumber(
        this.revision.prismaStats.totalExcluded()
      );
    },
    totalPending() {
      return this.formatNumber(
        this.revision.prismaStats.totalPending()
      );
    },
  },
  methods: {
    formatNumber(value) {
      if (value < 1000) {
        return value;
      } else {
        return (value / 1000).toFixed(1) + 'k';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/main.sass';

.breakdown-items {
  @extend .d-flex, .align-center;

  .breakdown-item {
    @extend .d-flex, .align-center, .mr-2;

    // Add some padding between the icons, text, and appended text
    & > * {
      @extend .mr-1;
    }

    .count-text {
      @extend .subtitle-1, .font-weight-bold;
    }

    .appended-text {
      @extend .text-body-2, .grey--text;
    }
  }
}
</style>
